export default __webpack_public_path__ + "static/media/fishes.efb69cde.png";